module.exports = __webpack_public_path__ + "img/11th_college.7a992152.webp";